import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import store from '@/store';
import { isEmailVerificationRequired } from '@/utils/authUtils';
import { waitForFirebaseAuth } from '@/utils/firebaseUtils';

/**
 * Router guards used to rely on volatile Vuex loginStatusCode, which resets on
 * every reload while Firebase auth persists. Re-resolve via /company/login when needed.
 */
export async function ensureLoginStatusResolved() {
  if (store.state.logoutInProgress) {
    return { user: null, loginStatusCode: null };
  }

  let user = firebase.auth().currentUser;
  if (!user) {
    user = await waitForFirebaseAuth();
  }

  if (!user || isEmailVerificationRequired(user)) {
    return {
      user: user || null,
      loginStatusCode: store.state.loginStatusCode,
    };
  }

  const cachedCode = store.state.loginStatusCode;
  if (cachedCode === 409 || cachedCode === 204 || cachedCode === 423) {
    return { user, loginStatusCode: cachedCode };
  }

  await store.dispatch('requestedLogin');
  return {
    user,
    loginStatusCode: store.state.loginStatusCode,
  };
}
